var addressRegexp = /^0x[0-9a-f]{40}$/i
export function isValidAddress(address) {
  return addressRegexp.test(address)
}

const regex = /^0x[0-9a-fA-F]{64}$/;
export function isValidBytes32(value) {
  return regex.test(value);
}
